<template>
  <div>
    <div class="flex fdr">
      <el-select class="filter__input" size="mini" v-model="localValue" filterable placeholder="不需要不用选" @change="$emit('input', $event)">
        <el-option :label="item.label" :value="item.value" v-for="(item, index) in lists" :key="index"></el-option>
      </el-select>
      <div class="ml-10" v-if="needEdit">
        <el-button size="mini" @click="initDetail(true)">添加账号</el-button>
      </div>
      </div>
    <el-dialog title="对接方编辑" :visible.sync="editDialog" size="tiny" width="800px" center>
     <el-form ref="form" :model="detail" label-width="80px">
        <el-form-item label="ID">
          <el-input v-model="detail.cdid" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="对接方">
          <el-radio-group v-model="detail.docking">
            <div class="dib mr-20">
              <el-radio :label="2">cayla系统</el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上家名字">
          <el-input v-model="detail.username"></el-input>
        </el-form-item>
        <el-form-item label="账号">
          <el-input v-model="detail.account"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="detail.password"></el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="detail.nickname"></el-input>
        </el-form-item>
        <el-form-item label="首页链接">
          <el-input v-model="detail.home"></el-input>
        </el-form-item>
        <div class="flex jcc mt-30">
          <div class="blue-large-btn mr-20" @click="detailEdit">保存</div>
          <div class="gray-large-btn" @click="editDialog = false">取消</div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import util from '../../script/util'
import {chnDockingLists, chnDockingEdit} from '../../api/api'
export default {
  props: {
    value: { // v-model 必须使用value名字
      required: true, // 必须传递该属性
      default: '' // 未传值时的默认值
    },
    needEdit: {
      type: Boolean, // 必须为字符串
      default: false // 未传值时的默认值
    }
  },
  data () {
    return {
      localValue: this.value,
      lists: [],
      editDialog: false,
      detail: {
        cdid: 0,
        docking: 2,
        username: '',
        account: '',
        password: '',
        nickname: '',
        home: '',
        status: 1
      }
    }
  },
  methods: {
    initValue () {
      this.localValue = this.value
    },
    initDetail (editDialog) {
      for (let key in this.detail) {
        this.detail[key] = ''
      }
      this.detail.cdid = 0
      this.detail.docking = 2
      this.detail.status = 1
      this.editDialog = editDialog
    },
    detailEdit () {
      let params = util.cloneObj(this.detail)

      let content = ''

      if (params['username'] === '') {
        content = '名字不能为空'
      }

      if (params['account'] === '') {
        content = '账号不能为空'
      }

      if (params['password'] === '') {
        content = '密码不能为空'
      }

      if (params['home'] === '') {
        content = '首页不能为空'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      chnDockingEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.initDetail(false)

          this.getLists()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getLists () {
      let params = {
        l: 1000,
        p: 1
      }
      chnDockingLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists.map((item, index) => {
            return {
              label: item.username,
              value: item.cdid
            }
          })
          if (this.needEdit === false) {
            this.lists.unshift({
              label: '所有',
              value: ''
            })
          }
        }
      })
    }
  },
  mounted () {
    this.getLists()
  },
  watch: {
    'value': 'initValue'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/data-select/chnDockingSelect.vue